module.exports = __webpack_public_path__ + "img/unsplash_LVcjYwuHQlg.abbc33a4.png";